import { createAPIInstance } from './api'
import qs from 'query-string'
import axios from 'axios'
import config, { getAdminApiBase } from '../env'

const profileApiBase = () => config.goService.replace(/\/$/, '')
const authHeaders = () => ({
  Authorization: `Token ${localStorage.getItem('token')}`
})

export function fetchAllAccounts(payload) {
  const adminApiBase = getAdminApiBase()
  return axios
    .get(
      `${adminApiBase}/user/apex/get_apex_accounts?pages=${payload.page}&status=${payload.status}&search_key=${payload.searchKey}&pending_documents=${payload.pending_documents}&transfer_request=${payload.transfer_request}`,
      {
        headers: {
          Authorization: `Token ${localStorage.getItem('token')}`
        }
      }
    )
    .then(response => response)
}

export function fetchAccountData(payload) {
  const adminApiBase = getAdminApiBase()
  return axios
    .get(
      `${adminApiBase}/user/apex/get_apex_details_for_account?apex_account_id=${payload}`,
      {
        headers: {
          Authorization: `Token ${localStorage.getItem('token')}`
        }
      }
    )
    .then(response => response)
}

export function fetchAccountStatus(payload) {
  const adminApiBase = getAdminApiBase()
  return axios
    .get(
      `${adminApiBase}/user/apex/account/status/admin?apex_account_id=${payload}`,
      {
        headers: {
          Authorization: `Token ${localStorage.getItem('token')}`
        }
      }
    )
    .then(response => response)
}

export const fetchRecentTransactions = async accountNo => {
  const { data } = await axios.get(
    `${config.tradeServiceBaseUrl}/v1/admin/user/get_details_for_account?account_no=${accountNo}`,
    {
      headers: {
        Authorization: `${localStorage.getItem('token')}`
      }
    }
  )
  return data
}
export function updateAccountStatus(payload) {
  return createAPIInstance()
    .post('user/apex/account/status/appeal', qs.stringify(payload))
    .then(res => res)
}

export function getApexAccountStatus(id) {
  const adminApiBase = getAdminApiBase()
  return axios
    .get(
      `${adminApiBase}/user/apex/account/status/admin?apex_account_id=${id}`,
      {
        headers: {
          Authorization: `Token ${localStorage.getItem('token')}`
        }
      }
    )
    .then(response => response.data)
}

export function saveForReview(payload) {
  return axios
    .post(`${profileApiBase()}/user/apex/snap/save`, payload, {
      headers: {
        'Content-Type': 'application/json',
        ...authHeaders()
      }
    })
    .then(response => response)
}

export function uploadReviewImage(payload) {
  return axios
    .post(`${profileApiBase()}/user/apex/snap/images`, payload, {
      headers: authHeaders()
    })
    .then(res => res.data.result)
}

export function downloadSnap(payload) {
  return axios
    .get(`${profileApiBase()}/user/apex/edocs/download`, {
      params: payload,
      responseType: 'arraybuffer',
      headers: authHeaders()
    })
    .then(response => response)
}

export function makeAppeal(payload) {
  const adminApiBase = getAdminApiBase()
  return axios.post(
    `${adminApiBase}/user/apex/account/status/appeal`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${localStorage.getItem('token')}`
      }
    }
  )
}

export function updateSnapStatus(payload) {
  const adminApiBase = getAdminApiBase()
  return axios
    .post(`${adminApiBase}/user/apex/snap/update`, payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${localStorage.getItem('token')}`
      }
    })
    .then(response => response)
}

export function requestAction(payload) {
  const adminApiBase = getAdminApiBase()
  return axios
    .post(`${adminApiBase}/user/apex/approve/request`, payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${localStorage.getItem('token')}`
      }
    })
    .then(response => response)
}
export function updateRestrictedStatus(payload) {
  const adminApiBase = getAdminApiBase()
  return axios
    .post(
      `${adminApiBase}/user/apex/toggle/account/restriction/admin`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Token ${localStorage.getItem('token')}`
        }
      }
    )
    .then(response => response)
}
// export function getUsersAccountDetails(payload) {
//   return createAPIInstance()
//     .post('user/bank/details', qs.stringify(payload))
//     .then(res => res.data)
// }
//
// export function createUserAccount(payload) {
//   return createAPIInstance()
//     .post('user/account_requests_new', payload, {
//       headers: { 'Content-Type': 'application/json' }
//     })
//     .then(res => res.data)
// }
export function cancelAchRelation(payload) {
  const api = createAPIInstance()
  return api.post('/user/apex/ach_relation/cancel', payload, {
    headers: { 'Content-Type': 'application/json' }
  })
}

export function validateAddress(address) {
  const instance = axios.create({
    baseURL: `https://api.address-validator.net/api/verify?StreetAddress=${address.street}&City=${address.city}&PostalCode=${address.PostalCode}&CountryCode=${address.CountryCode}&Geocoding=true&APIKey=av-1583b5e36c10f33e4f81c2220d2a043e`
  })

  return instance.get()
}

export function updateUserAccountType(flag, userId) {
  return createAPIInstance().post(
    `user/apex/set/test/account/state?user_id=${userId}&flag=${flag}`,
    null,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${localStorage.getItem('token')}`,
        Cookie:
          'csrftoken=eTiPiqtPXYAA3bsv2QlHxFmvzwjABxcZn6go5ePnXg8ChXruwc65LbP5qNsrcxTW'
      }
    }
  )
}

export function updateRestrictUserStatus(userId) {
  return createAPIInstance().post(
    `user/restrict-user`,
    { user_id: userId },
    {
      headers: {
        'Content-Type': 'application/json',
        servicetoken:
          'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ',
        Cookie:
          'csrftoken=wiAwCAj2pXzjIxE9iHAkdBq5tlR6dgvGE1e7Dr0r6bcd7ML6JSwrdCaTHSRF95gT'
      }
    }
  )
}
export function resubmitRequestToApex(accId) {
  const adminApiBase = getAdminApiBase()
  return axios.post(
    `${adminApiBase}/user/apex/account/request/resubmit/admin`,
    { apex_account_id: accId },
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: `Token ${localStorage.getItem('token')}`
      }
    }
  )
}
export function exportAccountList(payload) {
  const adminApiBase = getAdminApiBase()
  return axios
    .get(`${adminApiBase}/export-account-list`, {
      params: payload,
      responseType: 'arraybuffer',
      headers: {
        Authorization: `Token ${localStorage.getItem('token')}`
      }
    })
    .then(response => response)
}

// close-account api
export function closeAccount(payload) {
  let userId = payload.account_id
  return createAPIInstance()
    .post(
      `/user/apex/close/account/admin?request_type=CLOSE_ACCOUNT&user_id=${userId}`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          servicetoken:
            'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ'
          // 'Cookie': 'csrftoken=wiAwCAj2pXzjIxE9iHAkdBq5tlR6dgvGE1e7Dr0r6bcd7ML6JSwrdCaTHSRF95gT'
        }
      }
    )
    .then(res => res.data)
}

export function searchUser({ user_id, email }) {
  const adminApiBase = getAdminApiBase()
  const params = user_id
    ? `user_id=${user_id}`
    : `email=${encodeURIComponent(email)}`
  return axios
    .get(`${adminApiBase}/user/search?${params}`, {
      headers: { Authorization: `Token ${localStorage.getItem('token')}` }
    })
    .then(res => res.data)
}

// toggle isActive Api
export function toggleisActive(id) {
  const adminApiBase = getAdminApiBase()
  return axios
    .post(`${adminApiBase}/update_account_status?account_id=${id}`, null, {
      headers: {
        Authorization: `Token ${localStorage.getItem('token')}`
      }
    })
    .then(response => response)
}

// export function updateRestrictedStatus(payload) {
//   return createAPIInstance()
//     .post(`user/apex/toggle/account/restriction/admin`, payload, {
//       headers: {
//         'Content-Type': 'application/json',
//         'servicetoken': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ',
//         'Cookie': 'csrftoken=wiAwCAj2pXzjIxE9iHAkdBq5tlR6dgvGE1e7Dr0r6bcd7ML6JSwrdCaTHSRF95gT'
//       }
//     })
// }
